// extracted by mini-css-extract-plugin
export default {"lib-header":"news_lib-header__3GXWW","lib-body":"news_lib-body__HNeZb","new-header":"news_new-header__rRowo","relative-news":"news_relative-news__bd3ag"};